/*
 * @Author: yu.lun
 * @Description: Modify here please
 */
import { request } from "@weapp/utils";
import { mainHost } from "../utils";
import { publicUrlapi } from "../constants";

const host = mainHost();

// 验证码校验
export const checkValidCode = (params: any) => {
  return request({
    url: `${host}${publicUrlapi}/papi/app/basicserver/password/checkValidCode`,
    method: "GET",
    params,
  });
};
